/**
 * Action types
 * @property {string}
 */
export const types = {
  COMPARE_UPDATE: "COMPARE_UPDATE",
};

/**
 * @namespace Reducers
 */
export const reducers = {
  /**
   * Updates state of listings being compared
   * @param {string} state
   * @param {object} action
   * @param {string} action.type
   * @param {array} action.listings
   * @memberOf Reducers
   */
  comparedListings(state = [], action) {
    switch (action.type) {
      case types.COMPARE_UPDATE:
        return action.listings;
      default:
        return state;
    }
  },
};

/**
 * @namespace Actions
 */
export const actions = {
  /**
   * Add listing to compared listings
   * @param {object} listing
   * @memberof Actions
   */
  add: listing => (dispatch, getState) => {
    const { comparedListings } = getState();

    if (
      !comparedListings.some(
        compared => compared.equipmentId === listing.equipmentId
      )
    ) {
      dispatch(actions.handleUpdate([listing, ...comparedListings]));
    }
  },

  /**
   * Clear compared listings
   * @param {array} listings
   * @memberof actions
   */
  clear: listings => ({
    type: types.COMPARE_UPDATE,
    listings: [],
  }),

  /**
   * Handle update to compared listings
   * @param {array} listings
   * @memberof Actions
   */
  handleUpdate: listings => ({
    type: types.COMPARE_UPDATE,
    listings: listings,
  }),

  /**
   * Remove listing from compared listings
   * @param {number|string} equipmentId
   * @memberof Actions
   */
  remove: equipmentId => (dispatch, getState) => {
    const { comparedListings } = getState();
    const updated = comparedListings.filter(
      compared => compared.equipmentId !== equipmentId
    );

    dispatch(actions.handleUpdate(updated));
  },
};
